var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCannedTestList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 5 L 3 9 L 7 9 L 7 5 L 3 5 z M 12 6 A 1.0001 1.0001 0 1 0 12 8 L 26 8 A 1.0001 1.0001 0 1 0 26 6 L 12 6 z M 3 13 L 3 17 L 7 17 L 7      13 L 3 13 z M 12 14 A 1.0001 1.0001 0 1 0 12 16 L 26 16 A 1.0001 1.0001 0 1 0 26 14 L 12 14 z M 3 21 L 3 25 L 7 25 L 7 21 L 3 21 z M 12 22 A       1.0001 1.0001 0 1 0 12 24 L 26 24 A 1.0001 1.0001 0 1 0 26 22 L 12 22 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannedTestList);
export default __webpack_public_path__ + "static/media/cannedTestList.96cee2c6ebb9b59e2fe9891070390d07.svg";
export { ForwardRef as ReactComponent };